import {ValidationDoc} from "@buildwitt/use-validate";
import {ILessonEntityPayload} from "@buildwitt/shapeshift-types";

const validateVideoUrl = (url: string): boolean => {
	if (!url || !url.trim()) return true; // Allow empty URLs

	const trimmedUrl = url.trim();

	// Only validate YouTube URLs - block if they have additional parameters like &list=
	if (trimmedUrl.includes("youtube.com/watch")) {
		const youtubePattern = /^https:\/\/www\.youtube\.com\/watch\?v=[^&]+$/;
		return youtubePattern.test(trimmedUrl);
	}

	// Allow all other URLs (Vimeo, other platforms, etc.)
	return true;
};

export const cohortLessonValidationDoc: ValidationDoc<ILessonEntityPayload> = {
	title: [{
		errorMessage: "required",
		validate: e => !!e.title
	}],
	videoUrl: [{
		errorMessage: "Invalid URL: Additional parameters are not allowed",
		validate: e => {
			if (e.videoType === "url" && e.videoUrl) {
				return validateVideoUrl(e.videoUrl.trim() || "");
			}
			return true;
		}
	}]
}